<template>
  <div>
    <GmapMarker
      v-for="busstop in busstops"
      :key="busstop.id"
      :position="busstop.location"
      :clickable="true"
      :draggable="false"
      :icon="icon(busstop)"
      :zIndex="1"
      @click="onMarkerSelected(busstop)" >
    </GmapMarker>
  </div>
</template>

<script>
import { gmapApi } from 'vue2-google-maps'
import { mapGetters } from 'vuex'

export default {
  methods: {
    icon: function (busstop) {
      if (this.google) {
        let size = new this.google.maps.Size(36, 36)
        if (this.selectedBusstop && busstop.id === this.selectedBusstop.id) {
          size = new this.google.maps.Size(62, 62)
        }
        return {
          url: this.iconPath(),
          scaledSize: size
        }
      }
    },
    iconPath() {
      return require('@/assets/images/mapmarker/pin_aibus@3x.png')
    },
    onMarkerSelected: function (busstop) {
      this.$store.dispatch('drawer/openBusstop', busstop)
    }
  },
  computed: {
    ...mapGetters({
      busstops: 'busstops/getAll',
      selectedBusstop: 'drawer/getTarget',
    }),
    google: gmapApi
  }
}
</script>
